module.exports = __webpack_public_path__ + "img/数据中心-1.9d1a674a.png";